import availablePaymentEngines from 'constants/PaymentEngine';
import { registerHandler } from '../paymentHandlerRegistry';

/**
 * MercadoPago credit card handler.
 * Handle credit card payments through the MercadoPago TDC form when the
 * payment engine is MercadoPago and credit card is enabled.
 * Submits the form via the MercadoPagoTDCContext.
 */
const mercadoPagoCreditCardHandler = {
  canHandle: ({ paymentEngine, env }) => {
    const mercadoPagoIsEnabled = env?.mercadoPago?.enabled;
    const creditCardEnabled = env?.mercadoPago?.creditCard?.enabled ?? false;
    return (
      mercadoPagoIsEnabled &&
      paymentEngine === availablePaymentEngines.mercadoPago &&
      creditCardEnabled
    );
  },

  execute: async ({ engineHooks }) => {
    await engineHooks.mercadoPagoTDC.submitForm();
  },
};

registerHandler('credit_card', mercadoPagoCreditCardHandler);
